"use strict";
import * as Bluebird from "bluebird";
var Queue = /** @class */ (function () {
    function Queue(maxWeight) {
        this.maxWeight = maxWeight;
        this.queue = [];
        this.run = false;
        this.runningWeight = 0;
    }
    Queue.prototype.enqueue = function (weight, task) {
        var _this = this;
        var promise = new Bluebird(function (resolve, reject) {
            _this.queue.push({
                task: task,
                weight: weight,
                resolve: resolve,
                reject: reject
            });
            _this.runTasks();
        });
        return promise;
    };
    Queue.prototype.runTasks = function () {
        if (!this.run) {
            return;
        }
        var nextTask;
        while (this.queue.length > 0 && this.runningWeight < this.maxWeight) {
            nextTask = this.queue.shift();
            this.runTask(nextTask);
        }
    };
    Queue.prototype.runTask = function (task) {
        var _this = this;
        this.runningWeight += task.weight;
        task.task().then(function (result) { task.resolve(result); }, function (error) { task.reject(error); }).finally(function () {
            _this.runningWeight -= task.weight;
            _this.runTasks();
        });
    };
    Queue.prototype.start = function () {
        this.run = true;
        this.runTasks();
    };
    return Queue;
}());
export default Queue;



//////////////////
// WEBPACK FOOTER
// ./js/asset/Queue.ts
// module id = iTly
// module chunks = 1 2 3